export default __webpack_public_path__ + "static/media/ladder.1aa1ddd4.png";